import { Colors } from '../../../constants';
import { StreamStatus } from '../../../enums';

export const statusToColorMap = new Map([
  [StreamStatus.Scheduled, Colors.MEDIUM_GREY], // Grey
  [StreamStatus.Initializing, Colors.WARNING], // Yellow
  [StreamStatus.Live, Colors.INFO], // Blue
  [StreamStatus.Complete, Colors.SUCCESS], // Green
  [StreamStatus.Error, Colors.ERROR], // Red
  [StreamStatus.Processing, Colors.PROCESSING], // Purple
  [StreamStatus.Restarting, Colors.RESTARTING], // Orange
  [StreamStatus.AwaitingSource, Colors.AWAITING_SOURCE], // Deep amber
  // Shares Processing's purple on purpose: it is the same part of the lifecycle -
  // the event is over and the recording is being turned into a video - and it
  // exists for seconds, so a colour of its own would be noise.
  [StreamStatus.SourceEnded, Colors.PROCESSING], // Purple
]);
